import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { useMemo } from 'react'
import { metodoPrograma } from '../../../../components/api'
import AutoComplete from '../../../../components/AutoComplete/AutoComplete'
import dayjs from 'dayjs'
import DateField from '../../../../components/DateField/DateField'

// import { dataMask } from '../../../../utils/masks'

const EdicaoLoteProduto = ({
  idProduto,
  dadosLote,
  voltar,
  codigoPrograma,
}) => {
  const retornaFornecedor = useMemo(
    () => ({
      idProduto,
      idLoteProduto: dadosLote?.[0] || undefined,
      acFornecedor: dadosLote?.[2] || [],
      idFornecedor: dadosLote?.[2]?.[0]?.[0] || '',
      nrLote: dadosLote?.[3] || '',
      dtFabricacao: dadosLote?.[4] ? dayjs(dadosLote[4]) : null,
      dtValidade: dadosLote?.[5] ? dayjs(dadosLote[5]) : null,
    }),
    [dadosLote, idProduto],
  )

  const salva = async (values) => {
    const payload = {
      ...values,
      nrLote: values?.nrLote ? String(values.nrLote) : null,
      dtFabricacao: dayjs(values.dtFabricacao).format('YYYY-MM-DD'),
      dtValidade: dayjs(values.dtValidade).format('YYYY-MM-DD'),
    }

    const res = await metodoPrograma('salvaLote', payload, codigoPrograma)
    if (res.status) voltar()
  }

  return (
    <Formik
      enableReinitialize
      initialValues={retornaFornecedor}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, setFieldValue, values }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <AutoComplete
                inputLabelProps={{ shrink: values.acFornecedor }}
                label="Fornecedor"
                metodo="buscaFornecedor"
                value={values.acFornecedor}
                onChange={(_, v) => {
                  setFieldValue('idFornecedor', v?.[0]?.[0])
                  setFieldValue('acFornecedor', v)
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrLote"
                label="Numero Lote"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <DateField
                label="Dt. Fabricação"
                fullWidth
                value={values?.dtFabricacao}
                onChange={(v) => setFieldValue('dtFabricacao', v)}
              />
            </Grid>
            <Grid item xs={3}>
              <DateField
                fullWidth
                label="Dt. Validade"
                value={values?.dtValidade || null}
                onChange={(v) => setFieldValue('dtValidade', v)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default EdicaoLoteProduto
